// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyAR8OTCjWycZIvtuBiMNcnSEJtxMYfawQc',
  authDomain: 'formizi.firebaseapp.com',
  databaseURL:
    'https://formizi-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'formizi',
  storageBucket: 'formizi.appspot.com',
  messagingSenderId: '552311019345',
  appId: '1:552311019345:web:c09c3f7d23633423dd6570',
  measurementId: 'G-G11TWD6PBD',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Firebase Authentication and get a reference to the service
// Enable session persistence
// setPersistence(auth, browserSessionPersistence)
//   .then(() => {
//     'Persistence successfully set';
//   })
//   .catch(error => {
//     // Handle errors here
//     console.error('Error setting persistence:', error);
//   });
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
